import { T } from "../../../app/tokens.js";
import { isActualsStale } from "../../../lib/projectFinancialAmounts.js";
export function ActualsThrough({ date, includesPlan = false }) {
  return <span style={{ fontSize: T.fsXxs, fontWeight: T.fwRegular, color: T.mid }}>
    {date ? <>through <span style={{ color: isActualsStale(date) ? T.ragAmberText : T.mid }}>
      {new Date(`${date.slice(0, 10)}T00:00:00Z`).toLocaleDateString("en-US", { month: "short", year: "numeric", timeZone: "UTC" })}
    </span></> : includesPlan ? "includes plan · actuals through unknown" : "Actuals through unknown"}
  </span>;
}
